import json from "@/assets/data.json";
import { ListToBeDisplayed } from "./utils";

// Initial state
export const state = {
  packageVersion: (process.env.PACKAGE_VERSION || "0") as string,
  dataIsLoaded: false as boolean,
  rawData: json as RawData | null,
  allGroupings: json.groupings as MapItems,
  allProcesses: json.processes as MapItems,
  allReasons: json.reasons as MapItems,
  allStakeholders: json.stakeholders as MapItems,
  groupings: json.groupings as MapItems,
  processes: json.processes as MapItems,
  reasons: json.reasons as MapItems,
  stakeholders: json.stakeholders as MapItems,
  selectedGroupingId: null as number | null,
  selectedProcessId: null as number | null,
  selectedReasonId: null as number | null,
  selectedStakeholderId: null as number | null,
  selectedListToDisplay: ListToBeDisplayed.None as ListToBeDisplayed,
  openedStakeholderGroups: [] as number[],
  expertModeCodeIsInvalid: false as boolean,
  expertModeCode: "" as string,
  searchedText: "" as string
};
export type State = typeof state;

export type RawData = {
  groupings: MapItems;
  processes: MapItems;
  reasons: MapItems;
  stakeholders: MapItems;
  subStakeholders: MapRelations;
  data: DelayCodeCombo[];
};

export type DelayCodeCombo = (string | number)[];

export type MapItems = { [key: string]: string };
export type MapRelations = { [key: string]: number };
